import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Navbar from './Navbar';
import Footer from './Footer';
import Home from './Home';
import About from './About';
import Contact from './Contact';
import ThankYou from './ThankYou';
import Privacy from './Privacy';
import CookiePolicy from './CookiePolicy';
import ChatAI from './ChatAI';
import CookieBanner from './components/CookieBanner';
import GoogleAnalytics from './components/GoogleAnalytics';
import AccessibilityFeatures from './components/AccessibilityFeatures';
import ColorBlindnessFilters from './components/ColorBlindnessFilters';

import './App.css';

function App() {
  // 1. Stato del tema: recupera la scelta salvata o imposta 'auto' come default
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'auto');

  useEffect(() => {
    const root = document.documentElement;

    // Funzione per applicare il tema corretto
    const applyTheme = (currentTheme) => {
      if (currentTheme === 'auto') {
        const isDarkSystem = window.matchMedia('(prefers-color-scheme: dark)').matches;
        root.setAttribute('data-theme', isDarkSystem ? 'dark' : 'light');
      } else {
        root.setAttribute('data-theme', currentTheme);
      }
    };

    applyTheme(theme);
    localStorage.setItem('theme', theme);

    // Gestione del cambio tema di sistema in tempo reale (solo se siamo in 'auto')
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleSystemChange = () => {
      if (theme === 'auto') applyTheme('auto');
    };

    mediaQuery.addEventListener('change', handleSystemChange);
    return () => mediaQuery.removeEventListener('change', handleSystemChange);
  }, [theme]);

  // 2. Funzione per ciclare tra i temi: Auto -> Light -> Dark
  const toggleTheme = () => {
    setTheme((prev) => {
      if (prev === 'auto') return 'light';
      if (prev === 'light') return 'dark';
      return 'auto';
    });
  };

  return (
    <HelmetProvider>
      {/* Google Analytics con Consent Mode */}
      <GoogleAnalytics />

      {/* Accessibility Features - Skip Links & ARIA */}
      <AccessibilityFeatures />

      {/* Color Blindness SVG Filters */}
      <ColorBlindnessFilters />

      <Router>
        <div className="app-wrapper">
          
          <div className="layout-container">
             <Navbar theme={theme} toggleTheme={toggleTheme} />
          </div>

          <main id="main-content" className="main-container" role="main">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/cookie" element={<CookiePolicy />} />
            </Routes>
          </main>

          <div className="layout-container">
            <Footer />
          </div>

          {/* CHICCA: La Chat AI appare sopra a tutto */}
          <ChatAI />

          {/* Cookie Banner GDPR */}
          <CookieBanner />

        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;